import { Component, ChangeDetectorRef } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';

import { IconDirective } from '@coreui/icons-angular';
import {
  ContainerComponent,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective
} from '@coreui/angular';

import { DefaultFooterComponent, DefaultHeaderComponent } from './';
import { navItems } from './_nav';
import { ConfigService } from '../../services/config.service';
import { CommonModule } from '@angular/common';

function isOverflown(element: HTMLElement) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

@Component({
    selector: 'app-dashboard',
    templateUrl: './default-layout.component.html',
    styleUrls: ['./default-layout.component.scss'],
    imports: [
        CommonModule,
        SidebarComponent,
        SidebarHeaderComponent,
        SidebarBrandComponent,
        RouterLink,
        IconDirective,
        NgScrollbar,
        SidebarNavComponent,
        SidebarFooterComponent,
        SidebarToggleDirective,
        SidebarTogglerDirective,
        DefaultHeaderComponent,
        ShadowOnScrollDirective,
        ContainerComponent,
        RouterOutlet,
        DefaultFooterComponent
    ]
})
export class DefaultLayoutComponent {
  public navItems = navItems;
  brandFull: any = {
    src: '',
    width: 100,
    height: 100,
    alt: 'Logo'
  };
  constructor(private configService: ConfigService, private changeDetectorRef: ChangeDetectorRef) { }

  onScrollbarUpdate($event: any) {
  }

  ngOnInit() {
    this.configService.getImageUrl('brandLogo.svg')
    .then((blob: Blob) => {
      const imageUrl = URL.createObjectURL(blob);
       this.brandFull = {
        src: imageUrl,
        width: 100,
        height: 100,
        alt: 'Logo'
      };
      this.changeDetectorRef.detectChanges();
      console.log(imageUrl);
    });
  }
}
